export function getEnumValue<T extends object>(enumObj: T, value: string): T[keyof T] | undefined {
    const enumValues = Object.values(enumObj);
    if (enumValues.includes(value as unknown as T[keyof T])) {
        return value as unknown as T[keyof T];
    }
    return undefined;
}
